import axios from 'axios'
import store from '@/store'
import Cookies from 'js-cookie'
import jwt_decode from "jwt-decode";
async function getUserData(token) {
    try {
        const { id } = jwt_decode(token);

        const result = await axios.get(`${process.env.VUE_APP_ROOT_API}/clients/v1/users/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        store.commit('user/setInfo', result.data.payload)
        Cookies.set('userInfo', JSON.stringify(result.data.payload), { expires: 1, domain: process.env.VUE_APP_ROOT_DOMAIN })
        return result.data.payload
    } catch (err) {
        store.commit('user/setLoading', false)
        if (err.data && err.data.message.name == 'TokenExpiredError') {
            return window.location.href = `${this.getServiceUrls.CLIENT}/`
        }
        return false
    }
}

export default getUserData